var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9492 1.96875L18.1328 1.10938C17.918 0.894531 17.5742 0.894531 17.4023 1.10938L9.625 8.88672L1.80469 1.10938C1.63281 0.894531 1.28906 0.894531 1.07422 1.10938L0.257812 1.96875C0.0429688 2.14062 0.0429688 2.48438 0.257812 2.69922L9.23828 11.6797C9.45312 11.8945 9.75391 11.8945 9.96875 11.6797L18.9492 2.69922C19.1641 2.48438 19.1641 2.14062 18.9492 1.96875Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownThin);
export default __webpack_public_path__ + "static/media/arrow-down-thin.1d968927dbfab72e438f4a84754c55b9.svg";
export { ForwardRef as ReactComponent };